import { useMemo } from 'react'

import { LOCALE } from 'interfaces/types'

import { useRouterExtend } from './useRouterExtend'

export type DetectPageReturnType = {
  isCarePath?: boolean
  isRoche?: boolean
  isSoya?: boolean
  isNestle?: boolean
  isTaganil?: boolean
  isNan?: boolean
  isCarePathKhumor?: boolean
  isDan?: boolean
  isSimilac?: boolean
  isTiki?: boolean
  isVinamilk?: boolean
  isConCung?: boolean
  isPfizer?: boolean
}

const detectPage = (slug: string, locale: LOCALE) => {
  let isCarePath = false
  let isRoche = false
  let isSoya = false
  let isNestle = false
  let isTaganil = false
  let isNan = false
  let isCarePathKhumor = false
  let isDan = false
  let isSimilac = false
  let isTiki = false
  let isVinamilk = false
  let isConCung = false
  let isPfizer = false
  if (slug === 'care-path') {
    isCarePath = true
    if (locale === LOCALE.Thailand) {
      isCarePathKhumor = true
    }
  } else if (
    locale === LOCALE.Vietnam &&
    (slug === 'phu-nu-chon-yeu-minh' || slug === 'de-co-tu-cung-len-tieng')
  ) {
    isRoche = true
  } else if (
    locale === LOCALE.Indonesia &&
    (slug === 'soya-content-hub' ||
      slug === 'festival-soya-2024' ||
      slug === 'hello-sehat-expert')
  ) {
    isSoya = true
  } else if (slug === 'nestle-s26' || slug === 'be-nghi-nhanh-me-co-du-nhay') {
    isNestle = true
  } else if (slug === 'cat-con-chong-mat') {
    isTaganil = true
  } else if (slug === 'co-dia-man-cam-o-tre' || slug === 'nan-content') {
    isNan = true
  } else if (slug === 'imunitas-dan-inteligensi') {
    isDan = true
  } else if (slug === 'similac' || slug === 'chien-binh-me-sinh-mo') {
    isSimilac = true
  } else if (slug === 'tiki') {
    isTiki = true
  } else if (slug === 'vnmoptimum') {
    isVinamilk = true
  } else if (slug === 'tieu-hoa-mien-dich-tri-nao') {
    isConCung = true
  } else if (slug === 'tuong-nho-nhung-hau-qua-to') {
    isPfizer = true
  }
  return {
    isCarePath,
    isCarePathKhumor,
    isRoche,
    isSoya,
    isNestle,
    isTaganil,
    isNan,
    isDan,
    isSimilac,
    isTiki,
    isVinamilk,
    isConCung,
    isPfizer,
  }
}

export const useDetectSCpage = (keyID = '') => {
  const {
    locale,
    query: { slug },
  } = useRouterExtend()
  return useMemo(() => detectPage(keyID || slug?.[0] || '', locale), [
    slug,
    keyID,
  ])
}
